module.exports = __webpack_public_path__ + "img/empty-member.841e7909.svg";